// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"495":"frontend","824":"portfolio","861":"blogs"}[chunkId] + "." + {"495":"69053a31","824":"c40c4fdb","861":"b0f8cffc"}[chunkId] + ".js";
};